import { useEffect, useRef, useState } from "react";
import { searchMedicineResearch } from "../services/medicineResearchSearch";

const MIN_SEARCH_LENGTH = 2;
const SEARCH_DEBOUNCE_MS = 300;

export const useMedicineResearchSearch = (searchQuery, isOTC) => {
	const [medicines, setMedicines] = useState([]);
	const [loading, setLoading] = useState(false);
	const requestIdRef = useRef(0);

	useEffect(() => {
		const trimmedQuery = searchQuery?.trim() || "";

		if (!trimmedQuery || trimmedQuery.length < MIN_SEARCH_LENGTH) {
			requestIdRef.current += 1;
			setMedicines([]);
			setLoading(false);
			return undefined;
		}

		const requestId = requestIdRef.current + 1;
		requestIdRef.current = requestId;
		setLoading(true);

		const timer = window.setTimeout(async () => {
			try {
				const response = await searchMedicineResearch(trimmedQuery, isOTC);
				if (requestId !== requestIdRef.current) {
					return;
				}

				setMedicines(response.data?.data || []);
			} catch (error) {
				console.error("Error fetching medicine research results:", error);
				if (requestId === requestIdRef.current) {
					setMedicines([]);
				}
			} finally {
				if (requestId === requestIdRef.current) {
					setLoading(false);
				}
			}
		}, SEARCH_DEBOUNCE_MS);

		return () => window.clearTimeout(timer);
	}, [searchQuery, isOTC]);

	return {
		medicines,
		loading,
		isActive: (searchQuery?.trim() || "").length >= MIN_SEARCH_LENGTH,
	};
};
